document.addEventListener('DOMContentLoaded', function() {
  const faqItems = document.querySelectorAll('.dvg-faq-item');
  function closeAllFaqs() {
    faqItems.forEach(item => {
      const answer = item.querySelector<HTMLDivElement>('.dvg-faq-answer');
      const question = item.querySelector<HTMLDivElement>('.dvg-faq-question');
      const toggleIcon = item.querySelector<HTMLSpanElement>('.dvg-faq-toggle i');
      if (answer && question && toggleIcon) {
        answer.style.display = 'none';
        question.classList.remove('active');
        toggleIcon.classList.remove('fa-minus');
        toggleIcon.classList.add('fa-plus');
      }
    });
  }
  faqItems.forEach(item => {
    const question = item.querySelector<HTMLDivElement>('.dvg-faq-question');
    const answer = item.querySelector<HTMLDivElement>('.dvg-faq-answer');
    const toggleIcon = item.querySelector<HTMLElement>('.dvg-faq-toggle i');
    if (question && answer && toggleIcon) {
      question.addEventListener('click', function () {
        const isActive = question.classList.contains('active');
        closeAllFaqs();
        if (!isActive) {
          question.classList.add('active');
          answer.style.display = 'block';
          toggleIcon.classList.remove('fa-plus');
          toggleIcon.classList.add('fa-minus');
        }
      });
    }
  });
});
